import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cc9e7488&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=cc9e7488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9e7488",
  null
  
)

export default component.exports